import { render, staticRenderFns } from "./Subtitle.vue?vue&type=template&id=3f5e3c3c&scoped=true&"
import script from "./Subtitle.vue?vue&type=script&lang=js&"
export * from "./Subtitle.vue?vue&type=script&lang=js&"
import style0 from "./Subtitle.vue?vue&type=style&index=0&id=3f5e3c3c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f5e3c3c",
  null
  
)

export default component.exports